import moment from 'moment';

export const defaultTimeRange = () => [moment().subtract(1, 'year'), moment()];
